module.exports = __webpack_public_path__ + "static/media/teletava5.7f37d2d2.png";